import { render, staticRenderFns } from "./NosologyDetail.vue?vue&type=template&id=e1f30778"
import script from "./NosologyDetail.vue?vue&type=script&lang=js"
export * from "./NosologyDetail.vue?vue&type=script&lang=js"
import style0 from "./NosologyDetail.vue?vue&type=style&index=0&id=e1f30778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports